(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anlu-foundation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anlu-section')) {
  class AnluSection extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.animationSet = new Set();
      this.depthFrame = 0;
      this.trackFrame = 0;
      this.autoDirection = 1;
      this.activeValue = -1;
      this.userPaused = false;
      this.autoPaused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.initialMotion = this.dataset.motion !== 'false';
      this.on(this.querySelector('[data-anlu-motion]'), 'click', () => {
        this.userPaused = !this.userPaused;
        this.updateMotion();
      });
      this.on(this.reduced, 'change', () => this.updateMotion());
      this.on(this.mobile, 'change', () => { this.animationSet.forEach(animation=>animation.finish()); this.updateTrack(); this.updateVideos(); this.updateDepth(); this.scheduleAuto(); });
      this.on(document, 'visibilitychange', () => { this.updateVideos(); this.scheduleAuto(); });
      this.initReveal();
      this.initTrack();
      this.initDepth();
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.updateVideos();
        this.scheduleAuto();
        this.updateDepth();
      }, this.classList.contains('anlu-values') ? {threshold:.2} : {rootMargin:'100px 0px'});
      this.visibilityObserver.observe(this);
      this.updateMotion();
      this.on(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.animationSet.forEach(animation => animation.finish());
        const card = event.target.closest('[data-anlu-card]');
        if (card && this.track) this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft, behavior:'instant'});
        this.focused = true;
        this.scheduleAuto();
      });
      this.on(document, 'shopify:block:deselect', () => {this.focused=false;this.scheduleAuto();});
    }
    on(target, name, callback, options={}) {
      if (target) target.addEventListener(name, callback, {...options, signal:this.signal});
    }
    get motionAllowed() {return this.initialMotion && !this.userPaused && !this.reduced.matches;}
    updateMotion() {
      this.dataset.motion = String(this.motionAllowed);
      const toggle = this.querySelector('[data-anlu-motion]');
      if (toggle) {
        toggle.setAttribute('aria-pressed',String(this.userPaused));
        if (!toggle.dataset.pauseLabel) toggle.dataset.pauseLabel=toggle.textContent;
        toggle.textContent=this.userPaused ? (this.dataset.resumeLabel || 'Resume motion') : toggle.dataset.pauseLabel;
      }
      if (!this.motionAllowed) this.animationSet.forEach(animation=>animation.finish());
      this.updateDepth();
      this.updateVideos();
      this.scheduleAuto();
    }
    initReveal() {
      if (!('IntersectionObserver' in window)) return;
      this.revealObserver = new IntersectionObserver(entries => {
        let index=0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          if (!this.motionAllowed || !entry.target.animate || window.Shopify?.designMode) return;
          const frames=this.mobile.matches ? [{opacity:.25},{opacity:1}] : [{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}];
          const animation=entry.target.animate(frames, {duration:this.mobile.matches?420:750,delay:this.mobile.matches?0:Math.min(index++*60,180),easing:'cubic-bezier(.22,.75,.25,1)',fill:'backwards'});
          if (entry.target.classList.contains('anlu-value') && !this.mobile.matches) this.animateValue(entry.target);
          this.animationSet.add(animation);
          animation.onfinish=()=>this.animationSet.delete(animation);
        });
      },{threshold:0.08});
      this.querySelectorAll('[data-anlu-reveal]').forEach(el=>this.revealObserver.observe(el));
    }
    initDepth() {
      this.depth=this.querySelector('[data-anlu-depth]');
      if (!this.depth) return;
      this.on(window,'scroll',()=>{
        if (!this.visible || !this.motionAllowed || this.mobile.matches || this.depthFrame || document.hidden) return;
        this.depthFrame=requestAnimationFrame(()=>{this.depthFrame=0;this.updateDepth();});
      },{passive:true});
      this.on(window,'resize',()=>this.updateDepth(),{passive:true});
    }
    updateDepth() {
      if (!this.depth) return;
      if (!this.motionAllowed || this.mobile.matches || window.Shopify?.designMode) {this.depth.style.transform='';return;}
      if (!this.visible) return;
      const rect=this.getBoundingClientRect();
      const progress=Math.max(0,Math.min(1,-rect.top/rect.height));
      this.depth.style.transform=`translateY(${progress*45}px) scale(${1+progress*.075})`;
    }
    updateVideos() {
      this.querySelectorAll('video').forEach(video=>{
        video.muted=true;video.defaultMuted=true;video.playsInline=true;
        video.setAttribute('muted','');video.setAttribute('playsinline','');
        if (this.visible && this.motionAllowed && !document.hidden && video.getClientRects().length) {
          const promise=video.play();if(promise)promise.catch(()=>{});
        } else video.pause();
      });
    }
    initTrack() {
      this.track=this.querySelector('[data-anlu-track]');
      if (!this.track) return;
      this.cards=Array.from(this.track.querySelectorAll('[data-anlu-card]'));
      this.prev=this.querySelector('[data-anlu-prev]');
      this.next=this.querySelector('[data-anlu-next]');
      this.navigation=this.querySelector('[data-anlu-navigation]');
      this.on(this.prev,'click',()=>{this.autoPaused=true;this.move(-1);this.scheduleAuto();});
      this.on(this.next,'click',()=>{this.autoPaused=true;this.move(1);this.scheduleAuto();});
      this.on(this.track,'scroll',()=>{
        if(this.trackFrame)return;
        this.trackFrame=requestAnimationFrame(()=>{this.trackFrame=0;this.updateTrack();});
      },{passive:true});
      this.on(this.track,'keydown',event=>{
        if(event.target!==this.track)return;
        if(this.canScroll && (event.key==='ArrowRight'||event.key==='ArrowLeft')){event.preventDefault();this.autoPaused=true;this.move(event.key==='ArrowRight'?1:-1);this.scheduleAuto();}
      });
      this.dots=Array.from(this.querySelectorAll('[data-anlu-value-dot]'));
      this.status=this.querySelector('[data-anlu-value-status]');
      this.dots.forEach((dot,index)=>this.on(dot,'click',()=>{
        this.autoPaused=true;
        const card=this.cards[index];
        if (card && this.canScroll) this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:this.motionAllowed?'smooth':'instant'});
        this.scheduleAuto();
      }));
      this.on(this.track,'pointerdown',()=>{this.autoPaused=true;this.scheduleAuto();},{passive:true});
      this.on(this,'pointerenter',()=>{this.hovered=true;this.scheduleAuto();});
      this.on(this,'pointerleave',()=>{this.hovered=false;this.scheduleAuto();});
      this.on(this,'focusin',()=>{this.focused=true;this.scheduleAuto();});
      this.on(this,'focusout',event=>{this.focused=this.contains(event.relatedTarget);this.scheduleAuto();});
      this.on(this.querySelector('[data-anlu-autoplay]'),'click',event=>{
        this.autoPaused=!this.autoPaused;
        event.currentTarget.setAttribute('aria-pressed',String(this.autoPaused));
        event.currentTarget.textContent=this.autoPaused ? (this.dataset.resumeLabel||'Resume motion') : (this.dataset.pauseLabel||'Pause motion');
        this.scheduleAuto();
      });
      this.resizeObserver=new ResizeObserver(()=>{this.updateTrack();this.scheduleAuto();});
      this.resizeObserver.observe(this.track);
      this.updateTrack();
    }
    updateTrack() {
      if (!this.track) return;
      const max=this.track.scrollWidth-this.track.clientWidth;
      const canScroll=max>3 && getComputedStyle(this.track).overflowX==='auto';
      this.canScroll=canScroll;
      if(this.navigation)this.navigation.hidden=!canScroll;
      this.track.tabIndex=canScroll?0:-1;
      if(this.prev)this.prev.disabled=this.track.scrollLeft<3;
      if(this.next)this.next.disabled=this.track.scrollLeft>=max-3;
      const fraction=this.track.scrollWidth ? (this.track.scrollLeft+this.track.clientWidth)/this.track.scrollWidth : 1;
      this.style.setProperty('--anlu-progress',`${Math.max(0,Math.min(100,fraction*100))}%`);
      if (this.dots?.length && this.cards.length) {
        const start=this.cards[0].offsetLeft;
        let closest=0;
        this.cards.forEach((card,index)=>{if(Math.abs(card.offsetLeft-start-this.track.scrollLeft)<Math.abs(this.cards[closest].offsetLeft-start-this.track.scrollLeft))closest=index;});
        this.dots.forEach((dot,index)=>dot.setAttribute('aria-current',String(index===closest)));
        if(this.status){
          this.status.setAttribute('aria-live',this.autoPaused?'polite':'off');
          this.status.textContent=this.dataset.statusTemplate.replace('__CURRENT__',String(closest+1));
        }
        if(closest!==this.activeValue){
          this.activeValue=closest;
          if(this.visible && this.mobile.matches && canScroll)this.animateValue(this.cards[closest]);
        }
      }

    }
    animateValue(card) {
      if(!this.motionAllowed || window.Shopify?.designMode || !card?.animate)return;
      const icon=card.querySelector('.anlu-value__icon');
      if(!icon)return;
      const effect=icon.animate([{opacity:.55,transform:'scale(.94)'},{opacity:1,transform:'scale(1)'}],{duration:500,easing:'cubic-bezier(.22,.75,.25,1)'});
      this.animationSet.add(effect);
      effect.onfinish=()=>this.animationSet.delete(effect);
      icon.querySelectorAll('svg>*').forEach(path=>{
        const draw=path.animate([{strokeDashoffset:'1'},{strokeDashoffset:'0'}],{duration:750,easing:'ease-out'});
        this.animationSet.add(draw);
        draw.onfinish=()=>this.animationSet.delete(draw);
      });
    }
    move(direction) {
      if(!this.cards?.length || !this.canScroll)return;
      const start=this.cards[0].offsetLeft;
      const positions=this.cards.map(card=>card.offsetLeft-start);
      const current=this.track.scrollLeft;
      const target=direction>0 ? positions.find(position=>position>current+4) : positions.slice().reverse().find(position=>position<current-4);
      this.track.scrollTo({left:target??(direction>0?this.track.scrollWidth:0),behavior:this.motionAllowed?'smooth':'instant'});
    }
    scheduleAuto() {
      clearTimeout(this.autoTimer);
      if (!this.track || this.dataset.autoplay!=='true' || !this.motionAllowed || !this.visible || this.autoPaused || this.hovered || this.focused || document.hidden || window.Shopify?.designMode || !this.canScroll)return;
      this.autoTimer=setTimeout(()=>{
        if(this.classList.contains('anlu-values')){
          if(this.next.disabled)this.autoDirection=-1;
          if(this.prev.disabled)this.autoDirection=1;
          this.move(this.autoDirection);
        } else if(this.next.disabled)this.track.scrollTo({left:0,behavior:'smooth'});else this.move(1);
        this.scheduleAuto();
      },Math.max(4,Number(this.dataset.delay)||6)*1000);
    }
    disconnectedCallback() {
      this.controller?.abort();this.revealObserver?.disconnect();this.visibilityObserver?.disconnect();this.resizeObserver?.disconnect();
      this.animationSet?.forEach(animation=>animation.cancel());
      cancelAnimationFrame(this.depthFrame);cancelAnimationFrame(this.trackFrame);clearTimeout(this.autoTimer);
    }
  }
  customElements.define('anlu-section',AnluSection);
}
  } catch(e) { console.error(e); }
})();

})();
